// Date formatting utility - dd/MM/YYYY format
export const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  
  return `${day}/${month}/${year}`;
};

// Alias for formatDate - for display purposes
export const formatDisplayDate = formatDate;

// Format date for input fields (YYYY-MM-DD)
export const formatDateForInput = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  
  return d.toISOString().split('T')[0];
};

// Format month/year for headers
export const formatMonthYear = (date, options = {}) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  
  const defaultOptions = { month: 'long', year: 'numeric' };
  return d.toLocaleDateString('en-GB', { ...defaultOptions, ...options });
};

// Format short month for compact views
export const formatShortMonth = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  
  return d.toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
};

// Parse date string to Date object (handles various formats)
export const parseDate = (dateString) => {
  if (!dateString) return null;
  if (dateString instanceof Date) return dateString;
  
  // Try ISO format first
  const d = new Date(dateString);
  if (!isNaN(d.getTime())) return d;
  
  // Try dd/MM/YYYY format
  const parts = dateString.split('/');
  if (parts.length === 3) {
    const [day, month, year] = parts;
    return new Date(year, month - 1, day);
  }
  
  return null;
};
